/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoFromJSON, FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoToJSON, } from './FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfo';
/**
 * Check if a given object implements the FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand interface.
 */
export function instanceOfFxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand(value) {
    if (!('PublicOrderId' in value) || value['PublicOrderId'] === undefined)
        return false;
    if (!('OrderPersonalInfo' in value) || value['OrderPersonalInfo'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandFromJSON(json) {
    return FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PublicOrderId': json['PublicOrderId'],
        'OrderPersonalInfo': FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoFromJSON(json['OrderPersonalInfo']),
    };
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandToJSON(json) {
    return FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandToJSONTyped(json, false);
}
export function FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommandToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PublicOrderId': value['PublicOrderId'],
        'OrderPersonalInfo': FxIdApplicationHandlersStoreUpdateOrderPIHandlerOrderPersonalInfoToJSON(value['OrderPersonalInfo']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersStoreUpdateOrderPIHandlerUpdateOrderPersonalInfoCommand.js.map